export default __webpack_public_path__ + "static/media/b41.5994a404.png";